<template>
  <div class="product-section" style="padding: 20px">
    <div style="margin-bottom: 10px" class="df both-side">
      <div class="title df vertical both-side">
        <a-date-picker
          v-model:value="requestPayload.localDate"
          @change="updateTable"
          style="width: 200px"
        >
        </a-date-picker>
        备份文件
      </div>
      <a-input
        placeholder="机身号"
        @change="handleSearch"
        v-model:value="requestPayload.serial"
        style="width: 200px"
      ></a-input>
    </div>
    <a-table
      :data-source="table.data"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
    >
      <template #filePath="{ record }">
        <a-button
          type="primary"
          size="small"
          v-if="record.filePath"
          @click="handleDownLoadFile(record.filePath)"
        >
          下载
        </a-button>
      </template>

      <template #action="{ record }">
        <a-space>
          <a-button type="danger" @click="handleUpdateFile(record)" size="small"
            >清空</a-button
          >
        </a-space>
      </template></a-table
    >
  </div>
</template>

<script>
import { defineComponent, watch, inject } from "vue";
import { useTable } from "@/views/notice/serve/table";
import {
  getBackupFileList,
  updateBackupFile,
} from "@/request/view/qualityInspection";
import { useRouter } from "vue-router";
import { debounce, timeStampToTime, Toast } from "@/utils";
import { showModal } from "@/views/repairprogress/serve/modal";
import { download } from "@/views/rdmanagement/serve/index";

export default defineComponent({
  setup() {
    const router = useRouter();

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({
      localDate: null,
      serial: null,
      type: 0,
    });

    const columns = [
      {
        title: "机身号",
        dataIndex: "serial",
        align: "center",
      },
      {
        title: "上传次数",
        dataIndex: "uploadNumber",
        align: "center",
      },
      {
        title: "文件",
        dataIndex: "filePath",
        align: "center",
        slots: {
          customRender: "filePath",
        },
      },
      {
        title: "操作",
        align: "center",
        slots: {
          customRender: "action",
        },
      },
    ];

    requestConfig.pull_fn = getBackupFileList;

    const handleUpdateFile = (record) => {
      showModal({
        title: "提示",
        toastText: "确认清空文件？",
        success: () => {
          updateBackupFile(record.id)
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getListData({ unPagingRequest: true });
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const getData = () => {
      getListData({ unPagingRequest: true });
    };

    const cascadeDate = inject("cascadeDate", null);

    const handleDownLoadFile = (file) => {
      download(file, "下载");
    };

    const handleSearch = debounce(() => {
      getData();
    }, 200);

    const updateTable = (e, stringDate) => {
      requestPayload.localDate = stringDate;
      handleSearch();
    };

    watch(
      () => cascadeDate,
      (val) => {
        if (val) {
          requestPayload.localDate = val.value.format("YYYY-MM-DD");
          getData();
        } else {
          requestPayload.localDate = null;
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      table,
      columns,
      handleSearch,
      getData,
      updateTable,
      requestPayload,
      handleDownLoadFile,
      handleUpdateFile,
    };
  },
});
</script>

<style lang="less" scoped>
.product-section {
  border-radius: 20px;
  box-shadow: 0 0 10px 0 #ccc;
  padding: 20px 0;
  // width: calc(100% - 40px);
  margin: 20px auto;
  .title {
    font-size: 20px;
    font-weight: bold;
    width: 300px;
  }
}
</style>
